<template>
	<div id="app">
		<keep-alive :include="['guessMusic', 'learnAndMoney']">
			<router-view />
		</keep-alive>
		<loading v-if="showLoading" :showLoading="showLoading"></loading>
		<!-- 新版公共toast -->
		<Toast v-if="toast.show" :toast="toast" />
		<!-- 公共弹窗 -->
		<div v-for="(modal, index) in ModalList" :key="index">
			<Modal
				v-if="modal.show"
				:overlay="modal.overlay"
				:type="modal.modalType"
				:closeFn="modal.closeFn"
				:btnFn="modal.btnFn"
				:closeBtnPos="modal.pos"
				:clickEmptyCloseModal="modal.clickEmptyCloseModal"
				v-bind="modal.props"
			/>
		</div>
	</div>
</template>

<script>
	import toast from './modules/toast.vue';
	import loading from './modules/loading.vue';
	import platform from './lib/platform';
	import { getUrlParams, getRmKReferrerHref } from './lib/common';
	import { mapGetters } from 'vuex';

	export default {
		data() {
			return {
				showToast: false,
				showLoading: false,
			};
		},
		components: {
			toast,
			loading,
		},
		created() {
			this.initEmit();
			this.sensorsAnalytics();
			// this.getIsCompliance();
		},
		computed: {
			...mapGetters({
				modal: 'modal',
				toast: 'toast',
				ModalList: 'ModalList',
			}),
		},
		mounted() {
			// 当前code 禁止unhandledrejection
			window.addEventListener('unhandledrejection', (event) => {
				if (event.reason && event.reason.code) {
					let { code } = event.reason;
					console.log(event.reason);
					if (code === '10001' || code === '10003' || code === '10005' || code === '10035' || code === '10037') {
						event && event.preventDefault();
					}
				}
			});
			// window.onerror = (msg, url, lineNum, colNum, err) => {
			// 	console.log(`错误发生的异常信息（字符串）:${msg}`);
			// 	console.log(`错误发生的脚本URL（字符串）:${url}`);
			// 	console.log(`错误发生的行号（数字）:${lineNum}`);
			// 	console.log(`错误发生的列号（数字）:${colNum}`);
			// 	console.log(`错误发生的Error对象（错误对象）:${err}`);
			// };
			// window.addEventListener(
			// 	'error',
			// 	(errorEvent) => {
			// 		console.log(errorEvent);
			// 		cosnole.log(errorEvent.message);
			// 	},
			// 	true
			// );
		},
		methods: {
			async getIsCompliance() {
				try {
					const {
						data: { is_compliance },
					} = await this.$post(this.$api.GET_IS_COMPLIANCE);
					console.log(`is_compliance`, is_compliance);
					this.$store.commit('setIsCompliance', is_compliance);
				} catch (e) {
					console.log(e);
				}
			},
			initEmit() {
				this.$bus.on('loading', this.LoadingFn);
			},
			destroyEmit() {
				this.$bus.off('loading', this.LoadingFn);
			},
			LoadingFn(obj) {
				if (!(obj instanceof Object && obj.show)) {
					obj = false;
				}
				this.showLoading = obj;
			},
			sensorsAnalytics() {
				// 神策初始化
				(async () => {
					const sa = window.sa;
					if (sa && sa.track) {
						let userInfo = this.$store.getters.client;
						// sa.logout();
						// if (userInfo.uid) {
						//   sa.login(userInfo.uid);
						// }
						let info = {
							platform: userInfo.platform,
							client_v: userInfo['app-v'] || userInfo['client-v'],
							sa_device_id: userInfo.sa_device_id,
							device_id: userInfo['device-id'],
						};
						if (info.sa_device_id) {
							sa.login(info.sa_device_id);
						}

						let uid = !userInfo.tourist_token ? userInfo.uid : '';

						sa.registerPage({
							uid: uid || '',
							platform: info.platform || platform.platform,
							app_version: info.client_v || '',
							device_id: info.sa_device_id,
							device_new_time: info.device_new_time || '',
						});
						this.saRegisterPage();
						sa.quick('autoTrack');
					}
				})();
				// 神策初始化 end
			},

			saRegisterPage() {
				let sa = window.sa;
				if (sa && sa.track) {
					// 手动实现referrer， 结合SDK的openpage来使用
					let kReferrer = getUrlParams('k_referrer');
					let href = getRmKReferrerHref();
					if (kReferrer) {
						if (!/^http/.test(kReferrer)) kReferrer = window.location.origin + kReferrer;
					}
					let rg = {
						current_url: decodeURI(href),
						referrer: document.referrer ? decodeURI(document.referrer) : kReferrer || '',
						time: new Date().getTime(),
					};
					rg.source = getUrlParams('source') || '';
					if (this.$route.query.invite_code) {
						rg.invite_code = this.$route.query.invite_code;
					}
					if (this.$route.query.from_type) {
						rg.from_type = decodeURI(this.$route.query.from_type);
					}
					sa.registerPage(rg);
				}
			},
		},
		watch: {
			path: function () {
				this.saRegisterPage();
				const sa = window.sa;
				if (sa && sa.track) {
					sa.quick('autoTrack');
				}
			},
		},
	};
</script>

<style>
	#app {
		height: 100%;
	}
	.dialog {
		background: rgba(0, 0, 0, 0.6);
		position: fixed;
		z-index: 20;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}
	.dialog_con {
		position: absolute;
		left: 50%;
		top: 50% !important;
		transform: translate(-50%, -50%);
	}
	.dialog_close {
		position: absolute;
		/* bottom: -.63rem; */
		/* bottom: -.4rem; */
		width: 0.22rem;
		height: 0.22rem;
		background: url(./images/task/close.png) no-repeat;
		background-size: 100% 100%;
		top: -0.38rem;
		/* left: 50%; */
		right: -5%;
		transform: translateX(-50%);
	}
	.hiddenModalClose {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue